import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

export const getExportOptionsRequest = reatomAsync(async (ctx) => {
  return API.exporterQueueApi
    .exportControllerOptions({
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getExportOptionsRequest").pipe(
  withDataAtom({
    formats: [],
    formatsInfo: [],
    languages: [],
    transformers: [],
    exportFee: 0,
  }),
  withAbort(),
  withIsLoadingAtom(),
);
